import './NominatimSearch.css'

/**
 * Hooks
 */
import { useState, useContext, useEffect } from 'react'
import { useTranslation } from 'react-i18next'

/**
 * Utils
 */
import { getTool } from '../../utils/toolsHelper';

/**
 * Contexts
 */
import MapContext from '../Map/MapContext'
import { useGlobalVariablesContext } from '../../context/GlobalVariablesContext'

/**
 * OL
 */
import Point from 'ol/geom/Point'
import VectorLayer from 'ol/layer/Vector'
import VectorSource from 'ol/source/Vector'
import Feature from 'ol/Feature'
import { transform, transformExtent } from 'ol/proj'
import { Circle as CircleStyle, Fill, Stroke, Style } from 'ol/style'

const NominatimSearch = () => {
    const { map } = useContext(MapContext)
    const [query, setQuery] = useState('')
    const [results, setResults] = useState([])
    const [markerAdded, setMarkerAdded] = useState(false)
    const { t } = useTranslation()

    const { config } = useGlobalVariablesContext();
    const nominatimTool = getTool(config?.TOOLS, 'nominatimSearch');
    const conf = nominatimTool?.params;

    if (!nominatimTool || !conf) { return null }

    const styles = {
        top: conf.top,
        zIndex: conf.zIndex,
        width: conf.width
    }

    // función borrar marcador
    function removeLayer(layerName) {
        map.getLayers().forEach(layer => {
            if (layer && layer.get('name') === layerName) {
                map.removeLayer(layer)
            }
            setMarkerAdded(false)
        })
    }

    const search = async (query) => {
        if (!query) {
            setResults([])
            return
        }

        // const url = `https://nominatim.openstreetmap.org/search/${query}?format=json&addressdetails=1&extratags=1&limit=5&bounded=1&countrycodes=es`
        const url = `https://nominatim.openstreetmap.org/search?q=${query}&format=json&addressdetails=1&extratags=1&limit=5&bounded=1&countrycodes=${conf.countrycodes}`
        const response = await fetch(url)
        const data = await response.json()
        setResults(data)
    }

    const handleInputChange = (event) => {
        setQuery(event.target.value)
    }

    const handleSearch = () => {
        search(query)
    }

    const handleResultClick = (result) => {
        removeLayer('marcador')

        const markersLayer = new VectorLayer({
            source: new VectorSource({}),
            name: 'marcador',
            zIndex: 1200,
            style: new Style({
                image: new CircleStyle({
                    radius: 5,
                    fill: new Fill({
                        color: 'red'
                    }),
                    stroke: new Stroke({
                        color: 'rgba(255, 0, 0, 0.5)',
                        width: 10
                    })
                })
            })
        })
        map.addLayer(markersLayer)

        const markersSource = markersLayer.getSource()
        const marker = new Feature({
            geometry: new Point(transform([result.lon, result.lat], 'EPSG:4326', 'EPSG:3857')),
            name: 'marcador',
        })
        markersSource.addFeature(marker)

        const view = map.getView()
        // const bbox = transformExtent([result.boundingbox[2], result.boundingbox[0], result.boundingbox[3], result.boundingbox[1]], 'EPSG:4326', 'EPSG:3857')
        const bbox = transformExtent([result.boundingbox[3], result.boundingbox[0], result.boundingbox[2], result.boundingbox[1]], 'EPSG:4326', 'EPSG:3857')
        view.fit(bbox, { padding: [50, 50, 50, 50], duration: 500 })

        setQuery('')
        setResults([])
        setMarkerAdded(true)
    }

    const handleCloseResults = () => {
        setResults([])
        setQuery('')
        removeLayer('marcador')
    }

    useEffect(() => {
        if (!map) return

        const handleKeyDown = (event) => {
            if (event.key === 'Escape') {
                handleCloseResults()
            }
        }

        window.addEventListener('keydown', handleKeyDown)

        return () => {
            window.removeEventListener('keydown', handleKeyDown)
        }
    }, [])

    return (
        <div className='nominatim-search' style={styles}>
            <label htmlFor='nominatim-search-input'>
                {!markerAdded && (
                    <i className="bi bi-search" onClick={handleSearch}></i>
                )}

                <input
                    id='nominatim-search-input'
                    type='text'
                    value={query}
                    onChange={handleInputChange}
                    onKeyDown={(e) => e.key === 'Enter' && handleSearch()}
                    placeholder={t('Search location') || conf.placeholder}
                />
                {markerAdded && (
                    <i className="bi bi-x-circle close-icon" onClick={handleCloseResults}></i>
                )}
            </label>
            <div className='nominatim-results'>
                {results.length > 0 && (
                    <ul>
                        {results.map((result) => {
                            return (
                                <li key={result.place_id} onClick={() => handleResultClick(result)}>
                                    {result.display_name}
                                </li>
                            )
                        })}
                    </ul>
                )}
            </div>
        </div>
    )
}

export default NominatimSearch
